import moment from 'moment-timezone';
import { useWidgetContext } from 'widget/widget-context';

const useIsWorkingTime = (): boolean => {
  const { widget } = useWidgetContext();
  const { working_hours } = widget;

  const now = moment.tz(widget.timezone);
  const day = working_hours[now.day()];

  if (!day.isWorking) return false;
  else if (!day.end || !day.start) return true;

  const timestamp = +now.format('X');

  const [endHours, endMinutes] = day.end.split(':').map(Number);
  const [startHours, startMinutes] = day.start.split(':').map(Number);

  const end = moment.tz(widget.timezone);
  const start = moment.tz(widget.timezone);

  end.set({
    hours: endHours,
    minutes: endMinutes,
    seconds: 0,
    milliseconds: 0,
  });

  start.set({
    hours: startHours,
    minutes: startMinutes,
    seconds: 0,
    milliseconds: 0,
  });

  const endTimestamp = +end.format('X');
  const startTimestamp = +start.format('X');

  return timestamp > startTimestamp && timestamp < endTimestamp;
};

export default useIsWorkingTime;
